import { render, staticRenderFns } from "./twitterAccountOrder.vue?vue&type=template&id=216f2ae4&"
import script from "./twitterAccountOrder.vue?vue&type=script&lang=js&"
export * from "./twitterAccountOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports